import { useChains } from "src/components/FetchConfig";
import { FilterFields } from "../types/FilterFields";
import { cleanObject, cleanStrArray } from "src/utils/helper";
import { defaultListParams } from "src/features/common/constants/defaultListParams";
import { ListParams } from "../types/ListParams";

function useGetListParams() {
  const { selectChainByPieces } = useChains();

  const getListParams = (fields: FilterFields): ListParams => {
    const { client_id, chain_name, currency: asset_name } = fields;

    const client_ids = cleanStrArray(client_id.split(","));

    const { chain_id, chain_type } = selectChainByPieces({ chain_name });

    const params = {
      asset_name,
      client_ids,
      chain_id,
      chain_type,
    };

    return { ...cleanObject(params), ...defaultListParams };
  };

  return { getListParams };
}

export default useGetListParams;
